import { FaUser } from "react-icons/fa";
import { useState } from "react";

const CnamModal = ({ onClose, onSubmit }) => {
  const [cnam, setCnam] = useState("");

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-gray-700 p-6 rounded-lg">
        <h2 className="text-xl text-white font-semibold mb-4">
          <FaUser className="inline-block mr-2" />
          Create a CNAM (Caller Id)
        </h2>
        <div className="flex flex-col text-gray-300 mb-4">
          <label className="mb-2 font-medium">CNAM (Caller Id):</label>
          <input
            type="text"
            value={cnam}
            maxLength={15}
            onChange={(e) => setCnam(e.target.value)}
            className="bg-gray-600 text-white px-2 py-1 rounded w-full"
            placeholder="ex. CALLER ID"
          />
        </div>
        <div className="mt-4 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-500"
          >
            Cancel
          </button>
          <button
            onClick={() => onSubmit(cnam)}
            className="ml-2 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-500"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default CnamModal;
